import { all } from "redux-saga/effects";
import userSaga from "./user/saga";
import jobApplicantSaga from "./job-applicants/saga";
import jobMatchSaga from "./job-matches/saga"
import notificationSaga from './notifications/saga'

export default function* rootSaga(getState) {
  yield all([userSaga(), jobApplicantSaga(), jobMatchSaga(), notificationSaga()]);
}
